import * as fromDatatype from "../../../../models/datatype-library";

export class PickPackQueueLineDtoModel {
    generic_doc_line_guid: string;
    quantity: number;
}
  